import { defineComponent as _defineComponent } from 'vue'
import { mdiCheck } from '@mdi/js'
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import store from '@/store'
import { eventApi, EventDB } from '@/enitites/event'
import { computed, ref } from 'vue'
import { useRouter } from 'vue-router/composables'
import EventTicket from './EventTicket.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'BKCheckinButton',
  props: {
    event: null
  },
  emits: ["update:event", "checkIn", "purchase"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'update:event', value: EventDB): void
  (e: 'checkIn'): void
  (e: 'purchase'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  event: EventDB
};



const loading = ref(false)
const isShowTicketModal = ref(false)

const getUserDB = computed(() => store.getters.getUserDB)


const router = useRouter()

function redirectUnauthorized() {
  if (getUserDB.value) return
  router.push({ name: 'Signup' })
}

async function checkinUser() {
  redirectUnauthorized()
  loading.value = true
  const updatedEvent = await eventApi.checkinCurrentUser(props.event.id)
  loading.value = false

  if (updatedEvent) {
    emit('checkIn')
    emit('update:event', updatedEvent)
  }
}

return { __sfc: true,props, loading, isShowTicketModal, getUserDB, emit, router, redirectUnauthorized, checkinUser, mdiCheck, EventTicket }
}

})